import _ from 'lodash';
import * as d3 from 'd3';
import '../kickstart';
import dottedlinechart from './dottedlinechart';
import barchart from './barchart';
import { apnumber, intword } from 'journalize';
import selectAll from '../utils/select-all.js';

/* JOURNALIZE NUMBERS */
const formatVoters = d3.format(",d")
const formatPercent = d3.format(",.1")
const numbers = window.DATA.numbers
const res = window.DATA.res
const turnout = window.DATA.turnout


/*window.odometerOptions = {
  auto: false, // Don't automatically initialize everything with class 'odometer'
  selector: '.total-number', // Change the selector used to automatically find things to be animated
  format: '(,ddd)', // Change how digit groups are formatted, and how many digits are shown after the decimal point
  duration: 2000, // Change how long the javascript expects the CSS animation to take
  theme: 'default', // Specify the theme (if you have more than one theme css file on the page)
  animation: 'count' // Count is a simpler animation method which just increments the value,
                     // use it when you're looking for something more subtle.
}
let od = new odometer({
  el: document.querySelector('.total-number'),
  value: numbers.total,
});

od.render()*/
selectAll(".total-day").forEach(span => {
	span.textContent = apnumber(numbers.day)
})
selectAll(".total-in-person").forEach(span => {
	span.textContent = formatVoters(numbers.in_person)
})
selectAll(".total-mail").forEach(span => {
	span.textContent = formatVoters(numbers.mail)
})
selectAll(".total-reg-voters").forEach(span => {
	//console.log(intword(numbers.reg_voters))
	span.textContent = intword(numbers.reg_voters)
})

selectAll(".total-percent-of-2014").forEach(span => {
	span.textContent = (numbers.percentof14*100).toFixed(0)
})

selectAll(".total-percent").forEach(span => {
	span.textContent = (numbers.percent*100).toFixed(1)
})

selectAll(".total-counties").forEach(span => {
	span.textContent = numbers.counties30
})

selectAll(".total-percent-voters").forEach(span => {
	span.textContent = (numbers.percentVoters30*100).toFixed(0)
})

const shiftWindow = () => scrollBy(0, -90);

// jumper element reference
const jumper = document.getElementById('nav-dropdown');

// add change listener
jumper.addEventListener('change', event => {
  // the element that changed (jumper)
  const el = event.target;

  // its current selected value
  const value = el.value;

  // find the element that matches (value has # in it, so use querySelector instead)
  const match = document.querySelector(value);

  // scroll the match into view
  match.scrollIntoView();

  // lil' nudge
  shiftWindow();
});


const data = res.filter(d => d.key != 'Total')
const total_data = res.filter(d => d.key == 'Total')

const dottedchart = new dottedlinechart()
const bars = new barchart()
const years = ['2018', '2016']
//const years = ['2018']
createTooltip()

//const el = d3.select('#counties-container')
function resizeTurnout() {
	const turnout_div = document.getElementsByClassName("turnout-chart")[0]
  	const bbox = turnout_div.getBoundingClientRect()
  	const { width } = bbox;
 	
  	const height = Math.min(300, window.innerHeight/2)
	bars.create(d3.select(".turnout-chart"), 
	  	turnout,
	  	{ width: width,
		 	height: height,
		 	margin: {top: 20, bottom: 20, right: 15, left: 50},
		 	yTicks: 3,
		 	tooltip: false,
		}
  	)
}
function resizeTotal() {
	const totals_div = document.getElementsByClassName("total-chart")[0]
  	const bbox = totals_div.getBoundingClientRect()
  	const { width } = bbox;
 
  const height = Math.min(300, window.innerHeight/2)
	dottedchart.create(d3.select(".total-chart"), 
  	{current: d3.nest()
	    .key(d => d['year'])
	    .entries(total_data[0].values), historic: total_data[0].historic},
	  	{ width: width,
			 	height: height,
			 	margin: {top: 20, bottom: 20, right: 110, left: 35},
			 	yTicks: 3,
			 	tooltip: false,
			}
  	)
}

function resizeCounties() {
  const counties_div = document.getElementById("counties-container")
  const bbox = counties_div.getBoundingClientRect()
  const { width } = bbox;
  const height = Math.min(300, window.innerHeight/2)
  d3.select('#counties-container').selectAll(".county-chart").each(function(d, i) {
  	//return d3.select(this).call(chart)	
  	dottedchart.create(d3.select(this), 
	{current: d3.nest()
		    .key(d => d['year'])
		    .entries(data[i].values), historic: data[i].historic},
		  { width: width,
			 	height: height,
			 	margin: {top: 20, bottom: 20, right: 110, left: 35},
			 	yTicks: 6,
			 	tooltip: true,
			}
	  )
	})
}
function resize() {
	//console.log(" i am resizingg")
	resizeTurnout()
	resizeTotal()
	resizeCounties()
}

window.addEventListener('resize', _.debounce(resize, 400))



//window.addEventListener('resize', resize)
resize()

function createTooltip() {
	var tooltip = d3.select("body").append("div")
	  .attr("class", "tooltip")
	  .on("click",function(){
	    tooltip.style("visibility","hidden");
	})

	tooltip.append("div")
	  .attr("class", "tooltip-day")

	let table = tooltip.append("table")
	  .attr("class", "tooltip-table")

	let headerLabels = ["year", "votes", "percent"]
	let headers = table.append("thead").append("tr")

	let header = headers.selectAll(".tooltip-header")
		.data(headerLabels)


	header
		.enter()
		.append("th")
		.attr("class", d => `tooltip-header cell-${d}`)
	.merge(header)
		.text(d => d)
		//.attr("colspan", )

	let rows = table.append("tbody")
	let row = rows.selectAll(".tooltip-row")
		.data(years)

	let rowEnter = row
		.enter()
		.append("tr")
		.attr("class", d => `tooltip-row y${d}`)
	.merge(row)

	let cell = rowEnter.selectAll(".tooltip-cell")
		.data(headerLabels)

	cell
		.enter()
		.append("td")
		.attr("class", d => `cell-${d} tooltip-cell`)
	.merge(cell)

	
}
